import whenDomReady from 'when-dom-ready';

function initialise() {
  const inputs = Array.from(document.querySelectorAll('.js-input-file'));

  inputs.forEach(input => {
    input.insertAdjacentHTML('afterend', `<span class="ds-form__file-name"></span>`);
    input.addEventListener('change', handleChange);
  });
}

/**
 * Handle the file input change.
 * @param {Event} event
 */
function handleChange(event) {
  const input = event.target;
  const fileNameEl = input.nextElementSibling;

  console.dir(event.target);

  let fileNames = [];

  if (event.target.files && event.target.files.length) {
    fileNames = Array.from(event.target.files).map(file => file.name);
  } else if (event.target.value && event.target.value.length) {
    let fakePath = event.target.value;
    fakePath = fakePath.replace('C:\\fakepath\\', '');
    fileNames.push(fakePath);
  } else {
    fileNames = ['Select a file'];
  }

  fileNameEl.innerText = fileNames.join(', ');
}

whenDomReady().then(initialise);
